module.exports = VConsole;


//////////////////
// WEBPACK FOOTER
// external "VConsole"
// module id = R7Hj
// module chunks = 107